/* @flow */
import React from 'react';
// $FlowIgnore
import { MdTimelapse } from 'react-icons/md';

export default function WaitIcon({
  style
}: Object): React.Element {
  return <MdTimelapse style={{...style}} />;
}
